module.exports = __webpack_public_path__ + "static/media/03-paolopascolo-hovercolor.52d21d93.jpg";